import styled, { css } from '@emotion/native';
import { isWeb } from '../utils/platform';
import { colors, spacing, getFontStyle, getBorderRadius } from '../constants';

const height = `${spacing.xl}px`;
const padding = `${spacing.xs}px`;
const iconHeight = `${spacing.xl}px`;
const iconWidth = `${spacing.xl}px`;
const maxWidth = '100%';

const baseStyles = css`
  width: 100%;
  min-height: ${height};
  padding: ${padding};
  border-radius: ${getBorderRadius('s')};
  border: 1px;
  border-color: ${colors.gray2};
  background-color: ${colors.white};
`;

const hoverStyles = css`
  background-color: ${colors.gray4};
`;

const disabledStyles = css`
  color: ${colors.gray1};
  background-color: ${colors.gray3};
  ${isWeb() ? css`cursor: not-allowed;` : ''}
`;

const errorStyles = css`
  border-color: ${colors.red};
`;

const focusStyles = css`
  border-color: ${colors.black};
`;

export const PressableIconWrap = styled.TouchableOpacity`
  position: absolute;
  right: 0;
  height: ${iconHeight};
  width: ${iconWidth};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.View`
  max-width: ${maxWidth};
`;

const labelHeight = `${spacing.m}px`;

export const Label = styled.Text`
  ${getFontStyle('s', 'semi')};
  display: flex;
  color: ${colors.gray1};
  align-items: center;
  width: 100%;
  min-height: ${labelHeight};
  margin-bottom: ${spacing.xxxs}px;
`;

export const HelpText = styled.Text`
  ${getFontStyle('s', 'semi')};
  display: flex;
  align-items: center;
  width: 100%;
  line-height: ${labelHeight};
`;

export const ErrorWrap = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: ${labelHeight};
  margin-bottom: 4px;
`;

export const ErrorText = styled.Text`
  ${getFontStyle('s', 'semi')};
  color: ${colors.red};
  padding-left: 4px;
`;

export const InputWrapper = styled.View`
  position: relative;
  max-width: ${maxWidth};
`;

type StyleProps = {
  hover?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  hasFocus?: boolean;
};

export const StyledTextInput = styled.TextInput<StyleProps>`
  ${baseStyles};
  ${getFontStyle()};
  ${(props) => props.hover && isWeb() && hoverStyles};
  ${(props) => props.disabled && disabledStyles};
  ${(props) => props.hasError && errorStyles};
  ${(props) => props.hasFocus && focusStyles};
`;

export const StyledRequired = styled.Text`
  color: ${colors.red};
`;
